export default "__VITE_PUBLIC_ASSET__7960a74c__"